/**
 * Encodes binary data to base64
 *
 * @param binary - The binary data to encode
 * @returns The base64 encoded string
 *
 * @group Utils
 *
 * @beta
 */
export function encodeBase64(binary) {
    return btoa(String.fromCharCode(...binary));
}
//# sourceMappingURL=encodeBase64.js.map